export { initializeFileTypeIcons } from './initializeFileTypeIcons';

export { getFileTypeIconProps } from './getFileTypeIconProps';

export { FileIconType } from './FileIconType';

export { FileTypeIconMap } from './FileTypeIconMap';

export { getFileTypeIconAsHTMLString } from './getFileTypeIconAsHTMLString';

export { getFileTypeIconAsUrl } from './getFileTypeIconAsUrl';

import './version';

export type { FileTypeIconSize, IFileTypeIconOptions, ImageFileType } from './getFileTypeIconProps';
